<template>
    <UplotVue
        :data="data"
        :options="options"
    />
</template>

<script>
import UplotVue from 'uplot-vue'
import 'uplot/dist/uPlot.min.css'

export default {
    components: {UplotVue},
    props: ['height', 'width', 'values'],
    data() {
        return {
            data: [
                Array.from(this.values.keys()),
                this.values,
                Array(this.values.length).fill(this.values[0]),
            ],
            options: {
                axes: [
                    {
                        show: false,
                    },
                    {
                        show: false,
                    }
                ],
                cursor: {
                    show: false,
                },
                legend: {
                    show: false,
                },
                scales: {
                    x: {
                        time: false,
                    },
                },
                series: [
                    {},
                    {
                        fill: this.fillGradient(),
                        stroke: this.strokeGradient(),
                        points: {
                            show: false
                        },
                        width: 1
                    },
                    {
                        stroke: 'black',
                        points: {
                            show: false
                        },
                        dash: [4, 4],
                    },
                ],
                select: {
                    show: false
                },
                height: this.height,
                width: this.width,
            },
        }
    },
    methods: {
        fillGradient() {
            let max = Math.max(...this.values)
            let min = Math.min(...this.values)

            let ratio = max / (max - min)

            let ctx = document.createElement('canvas').getContext('2d')
            const gradient = ctx.createLinearGradient(0, 0, 0, this.height * window.devicePixelRatio * 0.95)
            gradient.addColorStop(0, '#DDFFDD')
            gradient.addColorStop(ratio, '#DDFFDD')
            gradient.addColorStop(ratio, '#FFDDDD')
            gradient.addColorStop(1, '#FFDDDD')

            return gradient
        },
        strokeGradient() {
            let max = Math.max(...this.values)
            let min = Math.min(...this.values)

            let ratio = max / (max - min)

            let ctx = document.createElement('canvas').getContext('2d')
            const gradient = ctx.createLinearGradient(0, 0, 0, this.height * window.devicePixelRatio * 0.95)
            gradient.addColorStop(0, 'green')
            gradient.addColorStop(ratio, 'green')
            gradient.addColorStop(ratio, 'red')
            gradient.addColorStop(1, 'red')

            return gradient
        },
    },
};
</script>
